<div class="formgrid grid top-24 relative">
    <button pButton class="border-primary border-round bg-primary-reverse text-primary height-35" (click)="addSegment()" [label]="addSegmentText"></button>
</div>